import axios from 'axios'
import serverName from "./serverName"

const s= serverName
const prefix = 'api/portal-affairs/frontWeb'; //url前缀



// 下载文件
//参数：obj为后台返回的文件流 name为文件名, suffix是文件格式后缀
export function downloadFile(obj, name, suffix) {
    const url = window.URL.createObjectURL(new Blob([obj]))
    const link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    let fileName
    if (suffix) {
        fileName = name + '.' + suffix
    }
    else {
        fileName = name
    }
    link.setAttribute('download', fileName)

    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
}


//下载文件请求
export function downloadFileRequest(api, method, data, loading = true, head) {
    const accessToken = sessionStorage.getItem("accessToken")

    //设置头部header
    const headers = {
        // "userAuthType": "MS",
        'accessToken': accessToken
    }
    return new Promise((resolve, reject) => {
        const instance = axios.create({
            baseURL: '',
            timeout: 15000, // 请求超时时间
        })
        instance({
            // url: "/" + serverName + api,
            url: s!='' ? "/" + s + prefix + api : prefix + api,
            headers: head ? head : headers,
            method: method,
            data: data,
            responseType: 'blob'
        }).then(res => {
            if (res.status == 200) {
                resolve(res)
            } else {
                reject(res)
            }
            resolve(res) //回调
        })
            .catch(err => {
                reject(err) //回调
            })
    })
}

// 预览文件
export function filedyl(res, type_, fileId) {
    // let that = this;
    // type_ = type_.toLowerCase();
    let type = '';
    if (type_ == ".docx") {
        type = "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    } else if (type_ == ".doc") {
        type = "application/msword"
    } else if (type_ == ".gif") {
        type = "image/gif"
    } else if (type_ == ".jpeg" || type_ == ".jpg") {
        type = "image/jpeg"
    } else if (type_ == ".png") {
        type = "image/png"
    } else if (type_ == ".pdf") {
        type = "application/pdf"
    } else if (type_ == ".txt") {
        type = "text/plain;charset=utf-8'"
    } else if (type_ == ".xls") {
        type = "application/vnd.ms-excel" 
    } else if (type_ == ".xlsx") {
        type = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }else if (type_ == ".zip") {
        type = "application/zip"
    } else if (type_ == ".ppt") {
        type = "application/vnd.ms-powerpoint"
        
    } else if (type_ == ".pptx") {
        type = "application/vnd.openxmlformats-officedocument.presentationml.presentation"
    }
    // if (type_ == ".xlsx" || type_==".xls") {
    //     // $("#excelz").empty();//excel需要在预览的地方自己加dom展示预览
    //     document.getElementById("excelz").innerHTML = "";
    //     let  name =  name_.split(".")[0];//预览文件的名字可以自行定义
    //     var nContainer = document.getElementById('excelz');
    //     var blob = new Blob([response.data], { type: type })
    //     var href = window.URL.createObjectURL(blob); //创建下载的链接
    //     var xlsx = new Plus.Xlsx(nContainer);
    //     xlsx.readFile(href);
    //     document.getElementById("excelz").prepend('<table id="table-preview" class="table table-striped table-hover"><thead style="width: 30%;"><tr><th>' + name + '</th></tr></thead></table>');
    //     setTimeout(function () {
    //         //td为0时不显示
    //         // 选取id为excelz的元素下的所有tr和td元素
    //         var trTds = document.querySelectorAll('#excelz tr td');
    //         // 使用forEach来迭代所有选中的trTds
    //         Array.prototype.forEach.call(trTds, function(td) {
    //             // 在这里处理每个td元素
    //             console.log(td.textContent); // 输出每个单元格的文本内容
    //             if(td.textContent == '0' || td.textContent == '0.00' || td.textContent == 0 || td.textContent == 0.00){
    //                 td.textContent('')
    //             }
    //         });
    //         // $("#excelz tr td").each(function () {
    //         //     if ($(this).text() == '0' || $(this).text() == '0.00' || $(this).text() == 0 || $(this).text() == 0.00) {
    //         //         $(this).text("");
    //         //     }
    //         // });
    //         //去除表4最后一列空列
    //         var _col_hide = true;
    //         // var len = $("table tr").length;
    //         var rows = document.querySelectorAll('#excelz tr');
    //         var len = document.querySelectorAll('table tr').length;
    //         for (var i = 0; i < len; i++) {
    //             if (rows.eq(i).find("td:last").text().trim() != '') {
    //                 _col_hide = false;
    //             }
    //         }
    //         if (_col_hide) {
    //             for (var i = 0; i < len; i++) {
    //                 rows.eq(i).find("td:last").remove();
    //             }
    //         }
    //         // $("#table-div, #close-table").show();
    //         document.getElementById('table-div').style.display = 'block';
    //         document.getElementById('close-table').style.display = 'block';
    //     }, 500);
    // } else {
    // }
    var blob = new Blob([res], { type: type })
    var href = window.URL.createObjectURL(blob); //创建下载的链接
    window.open(href);
    
}